export const IRIS_S1_PROMOTIONALBANNERDATA_GET_REQUEST =
    'IRIS_S1_PROMOTIONALBANNERDATA_GET_REQUEST';
export const IRIS_S1_PROMOTIONALBANNERDATA_GET_SUCCESS =
    'IRIS_S1_PROMOTIONALBANNERDATA_GET_SUCCESS';
export const IRIS_S1_PROMOTIONALBANNERDATA_GET_ERROR = 'IRIS_S1_PROMOTIONALBANNERDATA_GET_ERROR';
